export const LOGIN_FORM_FIELDS = [
  {
    key: "email",
    label: "Email",
    type: "email",
  },
  {
    key: "password",
    label: "Password",
    type: "password",
  },
];

export const REGISTER_FORM_FIELDS = [
  {
    key: "email",
    label: "Email",
    type: "email",
  },
  {
    key: "password",
    label: "Password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm Password",
    type: "password",
  },
  {
    key: "temporaryKey",
    label: "O.T.P",
    type: "text",
  },
];

export const VERIFY_EMAIL_FORM_FIELDS = [
  {
    key: "email",
    label: "Email",
    type: "email",
  },
];

export const FORGOT_PASSWORD_FORM_FIELDS = [
  {
    key: "email",
    label: "Email",
    type: "email",
  },
];

export const RESET_PASSWORD_FIELDS = [
  {
    key: "email",
    label: "Email",
    type: "text",
  },
  {
    key: "temporaryKey",
    label: "O.T.P",
    type: "text",
  },
  {
    key: "newPassword",
    label: "New Password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm New Password",
    type: "password",
  },
];
